import React from "react";
import { connect } from "react-redux";
import { startLogin } from "../actions/auth";
import { Redirect } from "react-router-dom";
import Loading from "./Loading";

class Impersonate extends React.Component {
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
	// localhost:3000/impersonate?token={}
	localStorage.setItem("impersonate",true)
	localStorage.setItem("user",JSON.stringify({token: params.get("token")}))
    const token = params.get("token");
    this.props.startLogin(token);
	window.location.reload()
  }
  render() {
    return <>{this.props.uid ? <Loading /> : <Redirect to="/" />}</>;
  }
}

const mapStateToProps = state => ({
  uid: state.auth ? state.auth.uid : undefined
});

const mapDispatchToProps = dispatch => ({
  startLogin: token => dispatch(startLogin(undefined, undefined, token))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Impersonate);
